import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=4050b194&scoped=true"
import script from "./MediaModal.vue?vue&type=script&lang=js"
export * from "./MediaModal.vue?vue&type=script&lang=js"
import style0 from "./MediaModal.vue?vue&type=style&index=0&id=4050b194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050b194",
  null
  
)

export default component.exports